export default __webpack_public_path__ + "b73593ab306990c8b6c9b474f5d4df3f.png";